import { Component, OnInit, Input, Output, EventEmitter, HostListener, ElementRef } from '@angular/core';
import { ToasterType } from './toaster.interface';

declare var $: any;

@Component({
  selector: 'toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss']
})
export class ToasterComponent implements OnInit {
  @Input() data;
  @Input() options;
  @Input() isOpen: boolean = false;

  @Output() closeToaster = new EventEmitter();

  public toasterTypeEnum = ToasterType;

  constructor(private elementRef: ElementRef) { }

  ngOnInit(): void {
  }
  // Make active selected flow item
  @HostListener('document:click', ['$event'])
  onMouseUp(e: any): void {
    if (this.isOpen) {
      const container = this.elementRef.nativeElement;
      !container.contains(e.target) && this.closeToasterEvent();
    };
  }

  closeToasterEvent() {
    this.closeToaster.emit({});
  }

  closeToasteronParentFocus() {
    this.closeToasterEvent();
  }

  rollBackFocusClose() {
    $("#toasterTextBtn").focus();
  }

  closeToasterEventFromKey(e) {
    if (e.key === 'Enter' || e.key === 'Space' || e.key === ' ') {
      this.closeToasterEvent();
    }
  }
}
